import React, { useContext } from "react";
import _ from "lodash";
import { Card, Caption, Link, Stack, DataTable, TextStyle } from "@shopify/polaris";

import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";

import { fulfillmentsProp } from "app/orders/modules/operator/features/view/propsType";

const Fulfillments = (props) => {
  const { cms } = useContext(PrivateContext);
  const { lineData, fulfillmentsCount, fulfillmentType, lineCount, setFulfillmentType } = props;
  const row = [];
  let totalQuantity;
  let fulfilledQuantity = 0;
  lineCount.forEach((item) => {
    if (item.fulfillableQuantity === 0) {
      fulfilledQuantity = fulfillmentsCount;
    }
  });
  let typeData = [];
  if (lineData) {
    lineData.forEach((value) => {
      const { lineItems } = value;
      lineItems.forEach((lineItem) => {
        const found = lineCount.find(
          (item) =>
            item.shopifyLineItemId === lineItem.id &&
            [constant.RESERVE, constant.COLLECT, constant.SERVICE].includes(item.fulfillmentType)
        );
        if (!found) {
          typeData = lineItem.fulfillmentType;
          row.push([
            <Stack.Item fill>
              <div className="ellipsis">
                <Link>{lineItem.name}</Link>
                <Caption>
                  <br />
                  <TextStyle>
                    {`${cms("label.vendor")}: `}
                    <Link>{lineItem.vendor}</Link>
                  </TextStyle>
                </Caption>
              </div>
            </Stack.Item>,

            <Stack.Item>{value.trackingCompany}</Stack.Item>,
            <Stack.Item>{value.trackingNumber}</Stack.Item>,
          ]);
        }
      });
    });
    if (!_.isEqual(fulfillmentType, typeData)) {
      setFulfillmentType(typeData);
    }
    totalQuantity = (lineCount && lineCount.length) || 0;
  }
  return (
    <Card>
      <Card.Section subdued>
        <DataTable
          columnContentTypes={["text", "text", "numeric"]}
          headings={[cms("label.product"), cms("label.shippingCompany"), cms("label.trackingNumber")]}
          rows={row}
        />
      </Card.Section>
      <Card.Section>
        <Stack>
          <Stack.Item fill>
            <TextStyle variation="strong">{cms("label.totalFulfillments")}</TextStyle>
          </Stack.Item>
          <Stack.Item>
            <TextStyle variation="strong">{`${fulfilledQuantity} ${cms("label.of")} ${totalQuantity}`}</TextStyle>
          </Stack.Item>
        </Stack>
      </Card.Section>
    </Card>
  );
};
Fulfillments.propTypes = fulfillmentsProp.type;
export default Fulfillments;
